import {styled} from "@mui/material/styles"

export type ContainerProps = {
    canScrollLeft: boolean
    canScrollRight: boolean
}

export const Container = styled("div", {
    shouldForwardProp: p => p !== "canScrollLeft" && p !== "canScrollRight",
})<ContainerProps>`
    display: flex;
    height: 100%;
    width: 100%;
    position: relative;
`
export type PositionedChevronProps = {
    isright: boolean
}

export const PositionedChevron = styled("div", {
    shouldForwardProp: p => p !== "isright",
})<PositionedChevronProps>`
    height: 100%;
    position: absolute;
    pointer-events: none;
    right: ${props => (props.isright ? 0 : "unset")};
    z-index: 10;
    align-items: center;
    align-content: center;
`
